/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formConstants } from '../../utils/constants/form-constants';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import FormBuilder from '../helpers/form-builder';
import FormMessage from '../../common/utility/FormMessage';
import FormSpinner from '../../common/utility/FormSpinner';
import * as registerFormActions from '../../../store/actions/register-form-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import initialState from '../helpers/form-helpers/initial-state';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import { deepCopyObject, isEmpty } from '../../utils/obj-utils';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import { hasValue } from '../../../../../general/js/general-helpers';
import { getFormContainerWideLeftClassList, getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { ssoFormTypes } from '../../utils/form-types';

class DefaultRegisterForm extends Component {
    constructor(props) {
        super(props);
        const { formData, formData: ssoDomain } = this.props;

        this.state = {
            ...initialState.defaultRegisterFormState,
            ssoDomain,
            isModalStylingUpdated: false
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();
        this.formReferences = formScrollHelpers.getFormReferences(formData);

        this.loadRegisterFormData = this.loadRegisterFormData.bind(this);
        this.displayDefaultRegisterForm = this.displayDefaultRegisterForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleUserRegisterSuccess = this.handleUserRegisterSuccess.bind(this);
        this.submitRegisterData = this.submitRegisterData.bind(this);

        this.loadRegisterFormData();
    }

    loadRegisterFormData() {
        const { actions, formData } = this.props;

        if (!hasValue(formData)) {
            actions.loadSSODefaultRegisterFormData();
        }
    }

    componentDidMount() {
        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.DefaultRegister);
    }

    componentWillReceiveProps(nextProps) {
        const {
            isRegisterSuccessful,
            loading,
            formData
        } = nextProps;

        if (hasValue(formData) && !hasValue(this.state.ssoDomain)) {
            this.state.ssoDomain = formData.ssoDomain;
        }

        if (hasValue(formData) && !hasValue(this.formReferences)) {
            this.formReferences = formScrollHelpers.getFormReferences(formData);
        }

        if (hasValue(formData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.DefaultRegister);
        }

        if (!loading &&
            isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserRegisterSuccess);
            return;
        }

        if (!loading &&
            !isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.defaultRegisterFormState);
        actions.resetRegisterFormState();
    }

    handleUserRegisterSuccess() {
        const { onUserRegisterSuccess } = this.props;
        const {
            formType,
            actionSuccessText,
            requestEmailVerificationCallbackUrl,
            requestEmailVerificationActionSuccessText
        } = this.props.formData;

        onUserRegisterSuccess(this.state[formConstants.emailAddress],
            {
                registerFormType: formType,
                successText: actionSuccessText,
                emailVerificationCallbackUrl: requestEmailVerificationCallbackUrl,
                emailVerificationActionSuccessText: requestEmailVerificationActionSuccessText
            });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            formData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }
        const captchaRef = this.formReferences[formConstants.reCaptcha];

        if (captchaRef) {
            captchaRef.current.props.grecaptcha.reset();
        }

        this.setState(formStateHelpers.updateSavingState(true), this.updateState);
    }

    updateState() {
        const { formData } = this.props;

        this.setState({ ssoEmailNotificationSettingsFields: formData.ssoEmailNotificationSettingsFields }, () => {
            this.submitRegisterData();
        });
    }

    submitRegisterData() {
        const { actions, formData } = this.props;
        const { callBackUrlPost } = formData;
        const actionSuccessText = formData.actionSuccessText || formMessageConstants.registrationSuccessText;

        actions.registerNewUser(this.state, actionSuccessText, callBackUrlPost);
        this.setState({ reCaptcha: '' });
    }

    displayForm() {
        const {
            onSignIn,
            onForgotPassword,
            isRegisterSuccessful,
            userRegistrationMessages,
            formData
        } = this.props;

        if (isEmpty(formData)) {
            return null;
        }

        const { formHeader } = formData;

        return (<Fragment>
            <SSOFormHeader
                headerTitle={formHeader.headerTitle}
                headerMessage={formHeader.headerMessage}
                headerLinkText={formHeader.headerLinkText}
                linkCallBackUrl={onSignIn}
                headerSecondMessage={formHeader.headerSecondMessage}
                headerSecondLinkText={formHeader.headerSecondLinkText}
                secondLinkCallBackUrl={onForgotPassword}
                displaySecondMessageAndLink={true}></SSOFormHeader>
            <form onSubmit={this.handleSubmit}>
                <FormMessage formRef={this.formMessageRef}
                    isSuccessMessage={isRegisterSuccessful}
                    messages={userRegistrationMessages}></FormMessage>
                {this.displayDefaultRegisterForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={formMessageConstants.submitDefaultFormButtonText}
                    footerLinkText={`${formMessageConstants.alreadyAMember} ${formMessageConstants.signInHere}`}
                    linkCallBackUrl={onSignIn}></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayDefaultRegisterForm() {
        const { formData } = this.props;
        const { mobilePhone } = formData;
        const copyOfFormData = deepCopyObject(formData);

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleMastercardNumberChange: (event) => {
                this.setState(formStateHelpers.handleMastercardNumberChange(event.target,
                    formData.mastercardRegex, formData.mastercardValidationError));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, formData } = this.props;

        const { formBanner, desktopImageSrc, mobileImageSrc } = formData;

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    <RegisterFormBanner
                        formBanner={formBanner}
                    ></RegisterFormBanner>
                    <div className='form-container__form'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div>
        );
    }
}

DefaultRegisterForm.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    onUserRegisterSuccess: PropTypes.func.isRequired,
    formData: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        formData: !hasValue(ownProps.registerFormData) ? state.registerForm.registerFormData : ownProps.formData,
        isRegisterSuccessful: state.registerForm.isRegisterSuccessful,
        userRegistrationMessages: state.registerForm.userRegistrationMessages,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadSSODefaultRegisterFormData: bindActionCreators(registerFormActions.loadSSODefaultRegisterFormData, dispatch),
            registerNewUser: bindActionCreators(registerFormActions.registerNewUser, dispatch),
            resetRegisterFormState: bindActionCreators(registerFormActions.resetRegisterFormState, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DefaultRegisterForm);
